var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyPhoto = function SvgEmptyPhoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "empty photo")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-photo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Photo_profile",
    fill: "#CFD5DA",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,5.6 C18.7130494,5.6 21.1114456,7.40552163 22.0355653,9.93907747 C22.2654121,10.4921118 22.4041394,11.1146392 22.4352298,11.8067251 L22.4419162,12.1075922 L22.4419162,16.7641359 C22.4419162,17.5778058 22.2982474,18.3006114 22.0352982,18.9328898 C21.3532963,20.8030223 19.867725,22.2765346 18.0049769,22.9198585 L18.0048529,24.2167468 C22.178336,25.1986709 25.4,28.9496008 25.4,33.4524946 L25.4,33.4524946 L25.4,36.6918294 L22.3281437,36.6918294 L22.3281437,45.6 L9.35808383,45.6 L9.35808383,36.6918294 L6.4,36.6918294 L6.4,33.4524946 C6.4,28.7886615 9.76602612,24.9315053 14.1362655,24.1221649 L14.1364578,23.0272089 C12.114583,22.4530124 10.4878235,20.915885 9.76443468,18.9326507 C9.50175261,18.3006114 9.35808383,17.5778058 9.35808383,16.7641359 L9.35808383,12.1075922 C9.35808383,11.2939224 9.50175261,10.5711167 9.76470183,9.9388384 C10.6885544,7.40552163 13.0869506,5.6 15.9,5.6 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Photo_profile",
    stroke: "#F0F0F0",
    strokeWidth: 0.8,
    mask: "url(#mask-2)",
    cx: 16,
    cy: 16,
    r: 15.6
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptyPhoto.1695fab6.svg";
export { ForwardRef as ReactComponent };